// MembershipLine Component (unchanged, used only for desktop)
const MembershipLine = ({ cardCount, selectedCardIndex }) => {
  return (
    <div className="relative w-full h-12 bg-transparent flex items-center justify-start">
      <div className="flex items-center w-full h-full px-4 gap-4">
        {Array.from({ length: cardCount }, (_, index) => (
          <div key={index} className="min-w-[350px] flex justify-center">
            <div
              className="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center font-bold text-sm"
              style={{
                background: selectedCardIndex === index ? 'linear-gradient(90deg, #00E1FF, #7F4FFF)' : 'transparent',
                border: selectedCardIndex !== index ? '1px solid #47556950' : 'none',
                color: selectedCardIndex === index ? '#fff' : '#000',
              }}
            >
              {index + 1}
            </div>
          </div>
        ))}
      </div>
      <div
        className="absolute top-1/2 h-px transform -translate-y-1/2 dashed"
        style={{
          background: "#00000015",
          backgroundSize: '10px 1px',
          backgroundRepeat: 'repeat-x',
          left: 'calc(1rem + 350px / 2)', // Start at the center of the first circle, using 1rem for consistency with px-4
          width: `calc((350px + 1rem) * ${cardCount - 1})`, // Span to center of last circle
        }}
      ></div>
    </div>
  );
};
export default MembershipLine;